<template>
  <v-app-bar
    app
    clipped-left
    fixed
  >
    <v-app-bar-nav-icon @click.stop="$emit('update:drawer', !drawer);"></v-app-bar-nav-icon>
    <v-toolbar-title>{{ $t(title) }}</v-toolbar-title>
    <v-spacer></v-spacer>
  </v-app-bar>
</template>

<script>
export default {
  data: () => ({
    drawer: null,
  }),
  props: ['title']
}
</script>

<style>

</style>